import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { FindMyDoorwayBlock } from "../components/HomeSections.jsx";
import Seo from "../components/Seo.jsx";

export default function FindMyDoorway() {
  const [params] = useSearchParams();
  const initialMood = params.get("mood");
  useEffect(() => {
    if (initialMood) document.getElementById("find")?.scrollIntoView({ behavior: "smooth" });
  }, [initialMood]);
  return (
    <>
      <Seo
        title="Find My Doorway · Simple Meditation World"
        description="Tell us how your mind feels today. We'll match you to a source-aligned practice from the 112 techniques."
        path="/find-my-doorway"
      />
      <FindMyDoorwayBlock />
    </>
  );
}
